import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

import './block-gallery.scss';

class BlockGallery extends PureComponent {
  constructor(...props) {
    super(...props);

    this.state = {
      activeIndex: 0
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.content.images !== this.props.content.images) {
      this.setState({ activeIndex: 0 });
    }
  }

  afterChange = (newIndex) => {
    this.setState({ activeIndex: newIndex });
  };

  render() {
    const { images } = this.props.content;

    return (
      <div className="block-gallery">
        {(images.length === 1) &&
          <img
            className="block-gallery-image"
            alt="Галерея"
            src={images[0].src}
          />
        }

        {(images.length > 1) &&
          <Slider
            ref={elem => { this.slider = elem; }}
            draggable={!!this.props.isMobile}
            infinite={false}
            speed={500}
            slidesToScroll={1}
            slidesToShow={1}
            afterChange={this.afterChange}
            touchThreshold={50}
          >
            {images.map((image, key) =>
              <div key={key}>
                <div
                  className="block-gallery-item"
                  style={{ backgroundImage: `url(${image.src})` }}
                />
              </div>
            )}
          </Slider>
        }

        <div>
          {(images.length > 1) &&
            <span className="block-gallery-counter">
              <i>{this.state.activeIndex + 1}</i> / {images.length}
            </span>
          }

          {(!!images.length) &&
            <span
              className="block-gallery-title"
              dangerouslySetInnerHTML={{ __html: images[this.state.activeIndex].title }}
            />
          }
        </div>
      </div>
    );
  }
}

BlockGallery.propTypes = {
  content: PropTypes.shape({
    images: PropTypes.arrayOf(
      PropTypes.shape({
        src: PropTypes.string,
        title: PropTypes.string
      })
    )
  })
};

export default BlockGallery;



// WEBPACK FOOTER //
// ./src/components/widgets/StaticRenderer/BlockGallery.js